import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { MessageListItem } from './MessageListItem';

export class MessageListTable extends React.Component {

    render() {
        const {
            data,
            error,
            loading,
        } = this.props;

        if ( error ) {
            return (
                <section className="error-section">
                    <h3 className="text-center">{error}</h3>
                </section>
            );
        }

        if ( !loading && data.length === 0 ) {
            return (
                <section className="error-section">
                    <h3 className="text-center">{I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS')}</h3>
                </section>
            );
        }

        return data.map((message) => (
            <MessageListItem
                key={message.id()}
                message={message}
            />
        ));
    }
}

MessageListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
};

MessageListTable.defaultProps = {
    data: [],
    error: '',
    loading: false,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/list/MessageListTable.jsx